var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalirDeudas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_PWA_deudaV2_line_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.721,
    height: 65.653,
    viewBox: "0 0 60.721 65.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16762",
    "data-name": "Grupo 16762",
    transform: "translate(1.282 1.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16761",
    "data-name": "Grupo 16761",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105411",
    "data-name": "Trazado 105411",
    d: "M87.192,15.315V30.331H69.456a10.335,10.335,0,0,0-7.309,3.027l-.052.052a7.632,7.632,0,0,1-5.4,2.235H37.944a2.565,2.565,0,0,1-.026-5.129c-.775,0-2.29,0-3.048,0a2.565,2.565,0,1,1,0-5.129c-.767,0-2.307,0-3.074,0a2.565,2.565,0,1,1,0-5.129c.7,0,2.747,0,3.039,0a2.565,2.565,0,0,1,.035-5.129c2.391,0,9.489,0,9.866,0A2.565,2.565,0,0,1,44.752,10c2.266,0,8.765,0,11.948,0a7.63,7.63,0,0,1,5.4,2.235l.052.052a10.336,10.336,0,0,0,7.309,3.027Z",
    transform: "translate(-29.232 -10)",
    fill: "#f7caa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105412",
    "data-name": "Trazado 105412",
    d: "M0,0H6.9V5.129H0Z",
    transform: "translate(48.512 27.977) rotate(90)",
    fill: "#98a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105413",
    "data-name": "Trazado 105413",
    d: "M344.2,282h11.118v5.129H344.2Z",
    transform: "translate(-303.813 -247.122)",
    fill: "#98a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105414",
    "data-name": "Trazado 105414",
    d: "M316.757,332.872A12.209,12.209,0,1,1,298.988,322h11.118A12.205,12.205,0,0,1,316.757,332.872Z",
    transform: "translate(-258.6 -281.993)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105415",
    "data-name": "Trazado 105415",
    d: "M350.164,41.451h9.589v17.58h-9.589Z",
    transform: "translate(-309.011 -37.418)",
    fill: "#98a1b3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16763",
    "data-name": "Grupo 16763"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1617",
    "data-name": "Elipse 1617",
    cx: 1.282,
    cy: 1.282,
    r: 1.282,
    transform: "translate(19.166 25.646)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105416",
    "data-name": "Trazado 105416",
    d: "M73.3,40.534V36.161a1.282,1.282,0,0,0-1.282-1.282H70.308V29.259a1.282,1.282,0,0,0-1.282-1.282H67.743v-3.8h3.513A1.282,1.282,0,0,0,72.538,22.9h5.935a1.282,1.282,0,0,0,1.282-1.282V6.6a1.282,1.282,0,0,0-1.282-1.282H72.538a1.282,1.282,0,0,0-1.282-1.282H61.666a1.282,1.282,0,0,0-1.282,1.274,8.991,8.991,0,0,1-6.052-2.645l-.014-.014-.035-.037A8.854,8.854,0,0,0,47.981,0H36.01a3.81,3.81,0,0,0-3.178,1.724A3.815,3.815,0,0,0,32.4,5.13H26.152a3.852,3.852,0,0,0-3.847,3.838,3.705,3.705,0,0,0,.233,1.329,3.85,3.85,0,0,0,0,7.62,3.86,3.86,0,0,0,3.077,5.13,3.786,3.786,0,0,0,.068,2.817,3.864,3.864,0,0,0,3.52,2.347h4.707a1.282,1.282,0,0,0,0-2.565h-4.7a1.294,1.294,0,0,1-1.165-.78l-.006-.014a1.291,1.291,0,0,1,1.161-1.77h8.631a1.282,1.282,0,1,0,0-2.565h-11.7a1.295,1.295,0,0,1-1.263-1.263c0-.006,0-.013,0-.019a1.284,1.284,0,0,1,1.281-1.282h9.883a1.282,1.282,0,0,0,0-2.565H23.059A1.295,1.295,0,0,1,21.8,14.125c0-.006,0-.013,0-.019a1.283,1.283,0,0,1,1.28-1.282H37.831a1.282,1.282,0,0,0,0-2.565H26.117A1.3,1.3,0,0,1,24.869,9c0-.006,0-.013,0-.019a1.284,1.284,0,0,1,1.282-1.282c5.136,0,12.143,0,17.189,0a1.282,1.282,0,1,0,0-2.565H36.018a1.293,1.293,0,0,1-1.164-.778l-.007-.016a1.291,1.291,0,0,1,1.174-1.77c2.311,0,8.577,0,11.961,0a6.306,6.306,0,0,1,4.476,1.847l.064.065a11.536,11.536,0,0,0,7.862,3.394V20.34a11.536,11.536,0,0,0-7.862,3.394l-.032.033.007-.008-.037.038a6.308,6.308,0,0,1-4.479,1.848H45.45a1.282,1.282,0,0,0,0,2.565h2.53a8.857,8.857,0,0,0,6.3-2.61l.033-.034-.007.008.036-.036A8.988,8.988,0,0,1,60.385,22.9a1.282,1.282,0,0,0,1.282,1.274h3.512v3.8H63.9a1.282,1.282,0,0,0-1.282,1.282v5.619H60.9a1.282,1.282,0,0,0-1.282,1.282v4.373a13.491,13.491,0,1,0,13.682,0Zm3.889-20.2H72.538V7.88h4.653ZM62.949,6.6h7.024V21.613H62.949Zm2.23,23.944h2.565v4.337H65.179Zm5.559,6.9v2.565H62.184V37.443ZM66.461,63.089A10.928,10.928,0,0,1,61.22,42.572H71.7a10.928,10.928,0,0,1-5.241,20.517Z",
    transform: "translate(-19.231 0)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105417",
    "data-name": "Trazado 105417",
    d: "M360.885,358.411a1.358,1.358,0,1,1,.942-2.336,1.282,1.282,0,1,0,1.784-1.843,3.9,3.9,0,0,0-1.443-.888v-.063a1.282,1.282,0,1,0-2.565,0v.065a3.922,3.922,0,0,0,1.282,7.629,1.358,1.358,0,1,1-.942,2.336,1.282,1.282,0,1,0-1.784,1.843,3.906,3.906,0,0,0,1.443.888v.063a1.282,1.282,0,1,0,2.565,0v-.065a3.922,3.922,0,0,0-1.282-7.629Z",
    transform: "translate(-313.655 -306.863)",
    fill: "#3b0310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalirDeudas);
export default __webpack_public_path__ + "static/media/salir-deudas.73fdfc98c4406ce822dcdc6049883ba1.svg";
export { ForwardRef as ReactComponent };